import { render, staticRenderFns } from "./type2.vue?vue&type=template&id=24ae5358&scoped=true"
import script from "./type2.vue?vue&type=script&lang=js"
export * from "./type2.vue?vue&type=script&lang=js"
import style0 from "./type2.vue?vue&type=style&index=0&id=24ae5358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae5358",
  null
  
)

export default component.exports